import React from "react";

export default function LearnMore() {
  return (
    <>
      <h1>Learn More</h1>
      <p className="metavote">
        <b>Plurality</b> voting is simple and familiar, but has many{" "}
        <a
          href="https://en.wikipedia.org/wiki/Plurality_voting#Disadvantages"
          target="_blank"
          rel="noopener noreferrer"
        >
          disadvantages
        </a>{" "}
        that result in it often being non-representative of the people's will in
        any election with more than two candidates. Many feel that it is
        seriously flawed and systemically reinforces a rigid two-party system
        with all the accompanying problems such as{" "}
        <a
          href="https://unsplitthevote.org/about/vote-splitting-problem/"
          target="_blank"
          rel="noopener noreferrer"
        >
          vote splitting
        </a>{" "}
        and{" "}
        <a
          href="https://en.wikipedia.org/wiki/Tactical_voting"
          target="_blank"
          rel="noopener noreferrer"
        >
          tactical voting
        </a>
        .
      </p>

      <p className="metavote">
        <b>Approval Voting</b> uses the same ballot as Plurality, but allows
        voters to support multiple candidates. It is promoted by{" "}
        <a
          href="https://www.electionscience.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          The Center for Election Science
        </a>{" "}
        which wrote{" "}
        <a
          href="https://www.electionscience.org/voting-methods/ten-critiques-and-defenses-on-approval-voting/#"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ten Critiques and Defenses of Approval Voting
        </a>
        .
      </p>

      <p className="metavote">
        <b>STAR Voting</b> combines scoring and ranking. The two highest scoring
        candidates are finalists and the finalist preferred by the majority
        wins.{" "}
        <a
          href="https://www.starvoting.us/"
          target="_blank"
          rel="noopener noreferrer"
        >
          STAR Voting
        </a>{" "}
        is promoted by the{" "}
        <a
          href="https://www.equal.vote/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Equal Vote Coalition
        </a>{" "}
        which wrote about{" "}
        <a
          href="https://www.equal.vote/science"
          target="_blank"
          rel="noopener noreferrer"
        >
          The Science
        </a>{" "}
        of voting.
      </p>

      <p className="metavote">
        <b>Ranked Choice Voting</b> ranks candidates in order of preference. It
        is promoted by{" "}
        <a
          href="https://www.fairvote.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          FairVote
        </a>{" "}
        which wrote about how{" "}
        <a
          href="https://www.fairvote.org/star_approval_and_ranked_choice_voting_share_common_goal_democratic_reform"
          target="_blank"
          rel="noopener noreferrer"
        >
          STAR, Approval and Ranked Choice voting share a common goal:
          democratic&nbsp;reform
        </a>
        .
      </p>
    </>
  );
}
